import { Link } from 'gatsby';
import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { Kfh_PropertyTypeInterface } from '../../types/graphqlTypes';
import { Tag } from '../Tag';
import { Typography } from '../Typography';
import PropertyPrice from './PropertyPrice';

interface PropertyPriceAndStatusProps {
  property: Kfh_PropertyTypeInterface;
  propertyCard?: boolean;
}

// Styles

const StyledPrice = styled.div`
  ${({ theme: { space, maxMedia } }) => css`
    display: flex;
    align-items: center;
    gap: ${space.sm};
    flex-wrap: wrap;
    @media (max-width: ${maxMedia.sm}) {
      margin-right: ${space.lg};
    }
  `};
`;

// JSX

const PropertyPriceAndStatus: FC<PropertyPriceAndStatusProps> = ({ property, propertyCard }) => {
  // Categorisation

  const isCommercial = property.commercial;
  const isRental = property.primaryCategory === 'rental';
  const showSellingState =
    property.sellingState === 'Under offer' ||
    property.sellingState === 'Sold' ||
    property.sellingState === 'Contracts exchanged';

  return (
    <>
      {/* Price and status */}

      <StyledPrice>
        {/* Sale price */}
        {property?.salesPrice !== 0 && (
          <Typography component="h2" variant={propertyCard ? 'titleMedium' : 'titleLarge'}>
            <PropertyPrice price={property.salesPrice} />
          </Typography>
        )}

        {property?.forSaleAndToLet && (
          <Typography component="h2" variant={propertyCard ? 'titleMedium' : 'titleLarge'}>
            {' '}
            OR{' '}
          </Typography>
        )}

        {/* Rental price */}
        {property?.rentalPrice !== 0 && (
          <Typography component="h2" variant={propertyCard ? 'titleMedium' : 'titleLarge'}>
            <PropertyPrice price={property.rentalPrice} />
            {isCommercial ? 'pa' : 'pcm'}
          </Typography>
        )}

        {/* Property status */}

        {showSellingState && <Tag text={property.sellingState} backgroundColor="black" />}

        {isRental && !property.available ? <Tag text="Recently let" backgroundColor="black" /> : ''}
      </StyledPrice>

      {/* Price details and prefix */}

      {property.rentalPeriod === 'ROA' && <h2>POA</h2>}
      {property.rentalPricePerWeek && property.rentalPricePerWeek !== 0 ? (
        <Typography component="p" variant={propertyCard ? 'bodySmall' : 'bodyLarge'}>
          <PropertyPrice price={property.rentalPricePerWeek} /> per week |{' '}
          <Link to="/tenants/fees">Fees may apply</Link>
        </Typography>
      ) : (
        ''
      )}

      {property.sellingState === 'Sold' ? (
        <Typography component="p" variant={propertyCard ? 'bodySmall' : 'bodyLarge'}>
          Asking price{' '}
        </Typography>
      ) : (
        property.pricePrefix && (
          <Typography component="p" variant={propertyCard ? 'bodySmall' : 'bodyLarge'}>
            {property.pricePrefix}
          </Typography>
        )
      )}
    </>
  );
};

export default PropertyPriceAndStatus;
